import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

let lang;
if (localStorage.getItem('lang')) {
  lang = localStorage.getItem('lang')
} else {
  localStorage.setItem('lang', 'en');
  lang = 'en'
}

/*
let country;
if (localStorage.getItem('country')) {
  country = localStorage.getItem('country')
} else {
  localStorage.setItem('country', 'Canada');
  country = 'Canada'
}
*/

function loadLocaleMessages () {
  const locales = require.context('./assets/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  //  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  locale: lang,
/*  messages: {
    'en': require('./assets/locales/en'),    //英文
    'chs': require('./assets/locales/chs'),  //簡體中文
    'cht': require('./assets/locales/cht')   //繁體中文
  },*/
})
